import React, { useState } from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareSquare } from "@fortawesome/free-solid-svg-icons";
import InterviewStatus from "./InterviewStatus";
import CandidateAbout from "./CandidateAbout";
import CvCount from "./CvCount";
import CandidateDescription from "./CandidateDescription";
import Modal from "../shared/general/Modal";
import DisplayPdf from "../shared/general/DisplayPdf";
import AgentDetails from "./AgentDetails";
import candidateAboutType from "./types/candidateAboutType";
import otherUserType from "./types/otherUserType";
import {
  CandidateInfoWrapper,
  Column,
  CvRow,
  ShareCvButton,
  ShareCvText,
  ShareCvIcon,
} from "./styles/candidate-info-styles";
import {
  ModalButton,
  ModalWrapper,
} from "../shared/general/styles/modal-styles";
import ShareModal from "./ShareModal/ShareModal";

const CandidateInfo = (props) => {
  const {
    jobStatus,
    lastAction,
    candidateAbout,
    cv,
    otherUser,
    candidateDescription,
    cvCount,
    isEmployer,
    interviewConfirmed,
    increaseApplicationCvReadCount,
    handleDownloadCv,
    emailDomains,
    applicationId,
    candidateId,
    showShareButton,
    jobCurrencySymbol,
  } = props;
  const isIe = detect().name === "ie";

  const [shareModalVisible, setShareModalVisible] = useState(false);

  return (
    <CandidateInfoWrapper className="candidate-info">
      <Column>
        <InterviewStatus
          jobStatus={jobStatus}
          lastAction={lastAction}
          interviewConfirmed={interviewConfirmed}
        />
        <CvRow>
          {isIe ? (
            <ModalWrapper>
              <ModalButton type="submit" onClick={handleDownloadCv}>
                Download CV
              </ModalButton>
            </ModalWrapper>
          ) : (
            <Modal
              buttonName="View CV"
              pdfUrl={cv}
              render={(data) => <DisplayPdf data={data} />}
              cvDownloadHandler={handleDownloadCv}
              candidateFooter
              modalButtonClickEvent={increaseApplicationCvReadCount}
            />
          )}
          {showShareButton && (
            <ShareCvButton
              data-test-id="share-modal-button"
              onClick={() => {
                setShareModalVisible(true);
              }}
            >
              <ShareCvText>Share</ShareCvText>
              <ShareCvIcon>
                <FontAwesomeIcon icon={faShareSquare} />
              </ShareCvIcon>
            </ShareCvButton>
          )}
          {shareModalVisible && (
            <ShareModal
              showModalFn={setShareModalVisible}
              emailDomains={emailDomains}
              candidateId={candidateId}
              applicationId={applicationId}
              candidateFullName={candidateAbout.full_name}
            />
          )}
        </CvRow>
        {!isEmployer && <CvCount cvCount={cvCount} />}
        {candidateDescription && (
          <CandidateDescription
            candidateDescription={candidateDescription}
            noMobile
          />
        )}
      </Column>
      <Column>
        <CandidateAbout
          about={candidateAbout}
          jobCurrencySymbol={jobCurrencySymbol}
        />
        {candidateDescription && (
          <CandidateDescription
            candidateDescription={candidateDescription}
            noDesktop
          />
        )}
        <AgentDetails
          name={otherUser.other_user_name}
          company={otherUser.company}
          avatar={otherUser.avatar}
        />
      </Column>
    </CandidateInfoWrapper>
  );
};

CandidateInfo.propTypes = {
  candidateAbout: candidateAboutType.isRequired,
  candidateDescription: PropTypes.string.isRequired,
  cv: PropTypes.string.isRequired,
  handleDownloadCv: PropTypes.func.isRequired,
  interviewConfirmed: PropTypes.bool.isRequired,
  jobStatus: PropTypes.string.isRequired,
  lastAction: PropTypes.string,
  otherUser: otherUserType.isRequired,
  cvCount: PropTypes.shape({
    cvOpenedCount: PropTypes.number,
    cvDownloadedCount: PropTypes.number,
  }),
  isEmployer: PropTypes.bool.isRequired,
  increaseApplicationCvReadCount: PropTypes.func.isRequired,
  emailDomains: PropTypes.arrayOf(PropTypes.string),
  applicationId: PropTypes.number.isRequired,
  candidateId: PropTypes.number.isRequired,
  showShareButton: PropTypes.bool.isRequired,
  jobCurrencySymbol: PropTypes.string.isRequired,
};

CandidateInfo.defaultProps = {
  lastAction: null,
  cvCount: null,
  emailDomains: null,
};

export default CandidateInfo;
